export default "/static-assets/_next/static/locales/en/common.3785f6f292a212245b42a42109eb85cd.json";